// this type file is specifically for the access token returned from the auth0 provider.
// any changes to the structure of the access token from auth0 should be reflected here.

import { Account, NotificationPreference, Role } from './account';
import { Client } from './client';
import { Contractor } from './contractors';

interface Acknowledgment {
    acknowledged: boolean;
    id: number;
    type: string;
    userId: number;
    version: number;
}

interface ChildClientPermission {
    id: number;
    accountId: number;
    clientId: number;
    permissionTypeId: string;
    account: Account | null;
    client: Client | null;
}

interface ContractorRelationship {
    teamId: number;
    teamTitle: string;
    contractorId: number;
    contractorName: string;
    clients: Client[];
    clientPaymentAccountId?: number;
}

interface ContractorTeam {
    id: number;
    userId: number;
    createdAt: string;
    updatedAt: string;
    afterHoursSupport: boolean;
    restrictToAssigned: boolean;
    externalCertifications: string;
    militaryBaseAccess: boolean;
    trades: string;
    assetTypes: string;
    serviceTypes: string;
    titleId: string;
    reassignWorkOrder: boolean;
    internalCertifications: string;
    contractor: Contractor;
}

interface ClientTeam {
    id: number;
    created: string;
    updated: string;
    accountId: number;
    client: Client;
}

interface User {
    acknowledgments: Acknowledgment[];
    active: boolean;
    availableForTesting: boolean;
    client: Client | null;
    childClientPermissions: ChildClientPermission[];
    clientTeam: ClientTeam | null;
    contractorRelationships: ContractorRelationship[];
    contractorTeam: ContractorTeam | null;
    createdAt: string;
    department: string[];
    departmentAssignment: string | null;
    email: string;
    emailVerified: string | null;
    firstName: string;
    forcePasswordChange: boolean;
    fullName: string;
    id: number;
    lastLogin: string;
    lastName: string;
    middleName: string | null;
    motiliRoles: Role[];
    notificationPreferences: string | null;
    phone: string | null;
    phoneCountry: string | null;
    preferences: NotificationPreference[];
    profilePhotoURL: string | null;
    realm: string;
    roles: Role[];
    states: string | null;
    statusId: number | null;
    timezoneId: string;
    title: string | null;
    updatedAt: string;
    userType: string;
    username: string;
}

interface AccessTokenUserResponse {
    userId: number;
    ttl: number;
    user: User | null;
    created: string;
    id: string;
}

export enum AccessTokenKeys {
    User = 'https://www.motili.com/user',
    S2Token = 'https://www.motili.com/s2Token',
}

export interface AccessToken {
    [AccessTokenKeys.User]: AccessTokenUserResponse;
    [AccessTokenKeys.S2Token]: string;
}

export type MotiliToken = AccessTokenUserResponse;
